import packageJSON from 'package.json';

const RequestHeadersPlatform = {
  'X-App-Platform': 'web',
  'X-App-Version': packageJSON.version,
};

export default RequestHeadersPlatform;
